module.exports = __webpack_public_path__ + "static/media/gustavo_brey.99bbace7.png";